namespace Areas.Finance.MonthlyGL{
    "use strict";

    const baseUrl = "/Finance/MonthlyGL";


    export function getCurrentGLBalance() {
        const form = $("#CurrentBalanceForm").dxForm("instance");
        const newData: any = form.option("formData");
        var lmoId: number = newData.uniqueId;

        if (lmoId != null) {
            $.get(`${baseUrl}/GetCurrentGLBalanceQuery/${lmoId}`,
                (data) => { form.option("formData", data) });
        }
    }

    export function updateGLBalance() {
        const form = $("#CurrentBalanceForm").dxForm("instance");
        const newData: any = form.option("formData");
        var lmoId = newData.uniqueId;

        const url = `${baseUrl}/MonthlyGLPost/${lmoId}`;
        const method = "POST";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage()
            });
    }

}